export default "__VITE_ASSET__Bjbsl7jQ__"